/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import colors from "assets/theme/theme-light/base/colors";
import borders from "assets/theme/theme-light/base/borders";
import boxShadows from "assets/theme/theme-light/base/boxShadows";
import rgba from "assets/theme/functions/rgba";

const { white, black } = colors;
const { borderWidth, borderRadius } = borders;
const { md } = boxShadows;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      color: black.main,
      backgroundColor: white.main,
      backgroundClip: "border-box",
      border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
      borderRadius: borderRadius.xl,
      boxShadow: md,
      overflow: "visible",
    },
  },
};

export default card;
